<template>
  <nav id="a-menu">
    <div class="menu-container">
      <ul class="menu-main">
        <li :class="{ en: lang === 'en' }">
          <router-link :to="`/${lang}/`" data-transition="menu">
            <div class="menu-l">
              <template v-if="lang === 'it'">
                <span>Essere</span>
                <span>Essere</span>
              </template>
              <template v-else>
                <span>Being</span>
                <span>Being</span>
              </template>
            </div>
            <div class="menu-s">{{ lang === 'en' ? 'About us' : 'About us' }}</div>
          </router-link>
        </li>
        <li>
          <router-link to="services" data-transition="menu">
            <div class="menu-l">
              <template v-if="lang === 'it'">
                <span>Elevare</span>
                <span>Elevare</span>
              </template>
              <template v-else>
                <span>Elevate</span>
                <span>Elevate</span>
              </template>
            </div>
            <div class="menu-s">{{ lang === 'en' ? 'Our Services' : 'I nostri servizi' }}</div>
          </router-link>
        </li>
        <li>
          <router-link to="team" data-transition="menu">
            <div class="menu-l">
              <template v-if="lang === 'it'">
                <span>Unire</span>
                <span>Unire</span>
              </template>
              <template v-else>
                <span>Unite</span>
                <span>Unite</span>
              </template>
            </div>
            <div class="menu-s">{{ lang === 'en' ? 'Our Team' : 'Our Team' }}</div>
          </router-link>
        </li>
      </ul>
      <router-link class="menu-contact" :to="`/${lang}/${lang === 'it' ? 'contatti' : 'contact'}`" data-transition="menu">
        <bdi v-if="lang === 'it'">Contattaci</bdi>
        <bdi v-else>Contact us</bdi>
      </router-link>
      <ul class="menu-info">
        <li>Adtelier</li>
        <li>Via Balzaretti, 36</li>
        <li>Milano - Italy</li>
        <li>
          T:
          <a href="tel:00390272008028">+39 0272008028</a>
        </li>
        <li>
          E:
          <a href="mailto:info@adtelier.it">info@adtelier.it</a>
        </li>
      </ul>
      <div class="menu-grid">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </nav>
</template>

<script>
import { app } from '@/utils/store';
import Menu from './menu';

let menu;

export default {
  data() {
    return {
      lang: app.language,
    };
  },
  mounted() {
    menu = new Menu();
    menu.init();
  },
};
</script>
